import { render, staticRenderFns } from "./FeedbackView.vue?vue&type=template&id=82bb9596&scoped=true"
import script from "./FeedbackView.vue?vue&type=script&lang=js"
export * from "./FeedbackView.vue?vue&type=script&lang=js"
import style0 from "./FeedbackView.vue?vue&type=style&index=0&id=82bb9596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bb9596",
  null
  
)

export default component.exports